import { inject } from '@angular/core';
import { FormDifferService, ModalService } from 'shared/services';
import { TranslateService } from '@ngx-translate/core';
import { CanDeactivateFn } from '@angular/router';
import { AuthenticationService } from 'authentication/services/authentication.service';

export function pendingChangesGuard(isCustomFieldsPage: boolean = false): CanDeactivateFn<boolean> {
    return () => {
        const authenticationService = inject(AuthenticationService);
        const formDifferService = inject(FormDifferService);

        if (
            authenticationService.isForceLogout ||
            Object.keys(isCustomFieldsPage ? formDifferService.getDiffWithOriginalValue() : formDifferService.getDiffWithSnapshot())
                .length === 0
        ) {
            return true;
        } else {
            const modalService = inject(ModalService);
            const translateService = inject(TranslateService);
            return modalService.openSimpleModal(
                translateService.instant('generalKeywords.leaveConfirmation'),
                translateService.instant('generalKeywords.leaveModalTitle'),
                translateService.instant('generalKeywords.yes'),
                translateService.instant('generalKeywords.no'),
                false,
                'top',
            ).onClose;
        }
    };
}
